import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useDispatch } from 'react-redux';

import { CandidateInfo } from '../../components/candidate_info/CandidateInfo';
import NavigationTabs from '../../navigation/NavigationTabs';
import OpenPositions from '../open_positions/OpenPositions';
import { fetchCandidateDetails } from '../../redux/actions/CandidateAction';
import { decrypt } from '../../util/Security';

const Home = (props) => {
    const { mobileView } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        let loggedIn = localStorage.getItem('login');
        if (loggedIn) {
            let data = decrypt(loggedIn);
            dispatch(fetchCandidateDetails(data?.candidateId));
        } else {
            navigate('/');
        }
    }, []);

    return (
        <Grid container>
            <Grid item xs={12} sm={7.5}>
                {mobileView ? (
                    <Contents mobileView={mobileView}  />
                ) : (
                    <Scrollbars autoHeight autoHeightMax='85vh' id='main'>
                        <Contents mobileView={mobileView} />
                    </Scrollbars>
                )}
            </Grid>
            <Grid item xs={12} sm={4.5} sx={{ zIndex: 100 }}>
                <OpenPositions mobileView={mobileView} />
            </Grid>
        </Grid>
    );
};
export default Home;

const Contents = ({mobileView}) => {
    return (
        <Grid container style={{ paddingBottom: mobileView ? 25 : 0 }}>
            <Grid item xs={12} sm={11.5} mx='auto'>
                <CandidateInfo mobileView={mobileView} />
            </Grid>
            <Grid item xs={12} sm={11.5} mx='auto'>
                <NavigationTabs />
            </Grid>
            <Grid item xs={12} sx={mobileView ? { mb: 8 } : null}>
                <Outlet context={[mobileView]} />
            </Grid>
        </Grid>
    );
};
